<template>
	<header class="eia-stage-header">

		<eia-stage-indicator :current-stage="currentStage"></eia-stage-indicator>

		<eia-heading level="h1"
			v-html="currentStageHeader"></eia-heading>

		<p class="eia-stage-header__sub-header"
			v-if="currentStage.subHeader">
			{{ currentStage.subHeader }}
		</p>

		<eia-accordion v-if="currentStage.help">
			<template slot="title">What does this mean?</template>
			<p>{{ currentStage.help }}</p>
			<p v-html="currentStage.help2"></p>
		</eia-accordion>
	</header>
</template>

<script>
import { nl2br } from '@/utils/string-utils';
import { mapState } from 'vuex';

export default {
	name: 'eia-stage-header',
	props: {
		currentStage: {
			type: Object,
			required: true,
		},
	},

	computed: {
		...mapState( 'stages', [ 'outcome' ] ),
		currentStageHeader() {

			if( typeof this.currentStage.header === 'function' ) {
				return this.currentStage.header();
			}

			if( this.currentStage.header === 'outcome' ){
				if( this.outcome?.name ){
					return this.outcome.name;
				}
			}

			return nl2br( this.currentStage.header );
		},
	},
};
</script>

<style lang="scss" scoped>
.eia-stage-header {
}

.eia-stage-header__sub-header {
	// font-weight: normal;
}
</style>
